import { FC } from 'react';

import { Box, Skeleton } from '@mui/material';

const CourseRegularHeaderPurchaseDetailSkeleton: FC = () => {
  return (
    <Box>
      <Skeleton animation="wave" variant="rectangular" sx={{ borderRadius: 2, mb: 5, height: { xs: 100, lg: 174 } }} />
      <Skeleton animation="wave" variant="rectangular" height={60} sx={{ borderRadius: 2 }} />
    </Box>
  );
};

export default CourseRegularHeaderPurchaseDetailSkeleton;
